const images = {
  // logoW: require('src/assets/images/logo-white.svg').default,
  logoW: require('src/assets/images/logo.svg').default,
  logo: require('src/assets/images/logo.svg').default,
  auth: {
    authBg: require('src/assets/images/auth/auth-bg.png'),
    login1: require('src/assets/images/auth/login-1.png'),
    icon: require('src/assets/images/auth/7icon.svg').default,
  },
};

export default images;
